// src/auth/Login.tsx
import React, { useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getLogin } from "../../../Services/ApiCalls";
import { setToken } from "../../../store/authSlice";

export default function Login() {
    const [email, setEmail] = useState("");
    const [pwd, setPwd] = useState("");
    const [err, setErr] = useState<string | null>(null);
    const [sp] = useSearchParams();
    const next = sp.get("next") || "/admin";
    const nav = useNavigate();
    const dispatch = useDispatch();

    const submit = async () => {
        setErr(null);
        try {
            // Use the API call from ApiCalls.ts
            const response = await getLogin(email, pwd);
            // Store the token in Redux store
            dispatch(setToken(response.token));
            console.log("Login successful:", response);
            nav(next, { replace: true });
        } catch (e: any) {
            setErr(e.message || "Login failed");
        }
    };

    return (
        <Box sx={{ maxWidth: 420, mx: "auto", py: 6 }}>
            <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>Login</Typography>
            <Stack spacing={2}>
                <TextField label="Email" value={email} onChange={e=>setEmail(e.target.value)} />
                <TextField label="Password" type="password" value={pwd} onChange={e=>setPwd(e.target.value)} />
                {err && <Typography color="error">{err}</Typography>}
                <Button variant="contained" onClick={submit}>Sign in</Button>
            </Stack>
        </Box>
    );
}